import type { DailyTacticalReadiness } from '../../services/operationsApi';

/** 지금 어느 단계에 있는지 한눈에 보여주는 여정 스트립. */
export default function FableJourney({ readiness }: Props) {
  const steps = buildSteps(readiness);
  return (
    <section className="fable-panel">
      <header className="fable-panel-head">
        <h3>지금 어디까지 왔나</h3>
        <p>왼쪽부터 순서대로 통과해야 합니다. 실전 매매는 마지막까지 잠겨 있습니다.</p>
      </header>
      <ol className="fable-journey">
        {steps.map((step) => (
          <li key={step.internal} className={`fable-step state-${step.state}`}>
            <span className="fable-step-badge">{stateBadge(step.state)}</span>
            <strong>{step.label}</strong>
            <p>{step.note}</p>
          </li>
        ))}
      </ol>
      <details className="fable-tech-ref">
        <summary>단계별 기술 식별자 보기</summary>
        <p>{steps.map((step) => <code key={step.internal}>{step.label}: {step.internal}</code>)}</p>
      </details>
    </section>
  );
}

type StepState = 'done' | 'current' | 'upcoming' | 'locked';

function stateBadge(state: StepState) {
  if (state === 'done') return '완료';
  if (state === 'current') return '현재';
  if (state === 'locked') return '잠김';
  return '대기';
}

function buildSteps(readiness: DailyTacticalReadiness) {
  const mode = readiness.flags.cohort_mode;
  const c = readiness.cohorts;
  return [
    {
      label: '배관 테스트',
      internal: 'plumbing',
      state: (mode === 'plumbing' ? 'current' : c.plumbing_run_count > 0 ? 'done' : 'upcoming') as StepState,
      note: `연결만 확인하는 HOLD 전용 기록 ${c.plumbing_run_count}건. 성과 판정에 쓰지 않습니다.`,
    },
    {
      label: '사전 리허설',
      internal: 'rehearsal',
      state: (mode === 'rehearsal' ? 'current' : c.rehearsal_run_count > 0 ? 'done' : 'upcoming') as StepState,
      note: `실제 모델·근거 저장을 검증하는 기록 ${c.rehearsal_run_count}건. 공식 기간에는 포함하지 않습니다.`,
    },
    {
      label: '공식 관찰',
      internal: 'official Stage A',
      state: (readiness.official_stage_clock_started ? 'current' : 'upcoming') as StepState,
      note: readiness.official_stage_clock_started
        ? `공식 기록 ${c.official_run_count}건 진행 중.`
        : '아직 시작 전입니다. 사용자 승인(GO) 후에만 시작합니다.',
    },
    {
      label: '실전 매매',
      internal: 'live / real capital',
      state: 'locked' as StepState,
      note: '공식 관찰 4-8주 통과와 사용자 승인 전까지 계속 잠김.',
    },
  ];
}

type Props = { readiness: DailyTacticalReadiness };
